import { ChakraProviderProps } from "@chakra-ui/react"
import { ClientContext } from "graphql-hooks"
import React from "react"

import { cmsClient } from "./"

export function CmsProvider({ children }: ChakraProviderProps) {
    return <ClientContext.Provider value={cmsClient.getClient()}>{children}</ClientContext.Provider>
}
